export default "__VITE_ASSET__D23fJ7RH__"